'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _fullscreenShareButtons = require('./fullscreenShareButtons.js');

var _fullscreenShareButtons2 = _interopRequireDefault(_fullscreenShareButtons);

var _fullscreenCartButton = require('./fullscreenCartButton.js');

var _fullscreenCartButton2 = _interopRequireDefault(_fullscreenCartButton);

var _fullscreenCheckoutLink = require('./fullscreenCheckoutLink.js');

var _fullscreenCheckoutLink2 = _interopRequireDefault(_fullscreenCheckoutLink);

var _utils = require('../utils');

var _mobileViewTypes = require('wix-art-store-3rd-party/dist/src/sdk/mobileViewTypes');

var _mobileViewTypes2 = _interopRequireDefault(_mobileViewTypes);

var _fullscreen = require('@wix/photography-client-lib/dist/src/versioning/features/fullscreen');

var _translationUtils = require('@wix/photography-client-lib/dist/src/utils/translationUtils');

var _translationUtils2 = _interopRequireDefault(_translationUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenSidebar = function (_React$Component) {
  (0, _inherits3.default)(FullscreenSidebar, _React$Component);

  function FullscreenSidebar(props) {
    (0, _classCallCheck3.default)(this, FullscreenSidebar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenSidebar.__proto__ || (0, _getPrototypeOf2.default)(FullscreenSidebar)).call(this, props));

    _this.state = {
      isStoreGallery: _utils.utils.isStoreGallery(),
      isSmallScreen: _utils.utils.isSmallScreen(),
      isMobile: _utils.utils.isMobile(),
      isStoreMobile: _utils.utils.isStoreGallery() && _utils.utils.isMobile(),
      isReadMoreVisible: false,
      isReadMoreOpen: false,
      hasShopElements: false
    };
    _this.shopFrameElement = null;
    _this.shopButtonsElement = null;
    return _this;
  }

  (0, _createClass3.default)(FullscreenSidebar, [{
    key: 'fixTextsLineHeight',
    value: function fixTextsLineHeight(isReadMoreOpen) {
      var elem = this.itemContainer;
      var title = (0, _jquery2.default)(elem).find('.fullscreen-side-bar-title');
      var description = (0, _jquery2.default)(elem).find('.fullscreen-side-bar-description');
      var availableHeight = 150;
      var numberOfLinesRequired = 3;
      var spaceBetweenTitleAndDescription = 0;
      var originalTitleHeight = 0;
      var originalDescriptionHeight = 0;

      var titleLineHeight = parseInt(title.css('line-height')) || 0;
      var numOfTitleLines = 0;
      var numOfDescriptionLines = 0;

      // reset truncation stuff
      title.css({ height: 'initial' });
      description.css({ height: 'initial' });
      title.css({ '-webkit-line-clamp': 'initial' });
      description.css({ '-webkit-line-clamp': 'initial' });

      if (title && title[0]) {
        // originalTitleHeight = title[0].scrollHeight - 18 //substructing the title margin-bottom
        originalTitleHeight = title[0].scrollHeight;
      }
      if (description && description[0]) {
        // originalDescriptionHeight = description[0].scrollHeight - 24 //substructing the description margin-bottom
        originalDescriptionHeight = description[0].scrollHeight;
      }

      if (!isReadMoreOpen) {
        var titleText = _utils.utils.getTitleOrFilename(this.props.current.item.title, this.props.fileName);
        if (this.props.styleParams.allowTitleExpand && titleText) {
          if (title && title.length !== 1) {
            return;
          }

          spaceBetweenTitleAndDescription = 30;

          numOfTitleLines = this.truncateElement(availableHeight, numberOfLinesRequired, title, originalTitleHeight);
          var titleHeight = numOfTitleLines * titleLineHeight;

          if (availableHeight > titleHeight) {
            availableHeight -= titleHeight;
          } else {
            availableHeight = 0;
          }
        }

        if (this.props.styleParams.allowDescriptionExpand && this.props.current.item.description) {
          if (description && description.length !== 1) {
            return;
          }

          availableHeight -= spaceBetweenTitleAndDescription;

          if (availableHeight <= 0) {
            description.hide();
            return;
          }

          numOfDescriptionLines = this.truncateElement(availableHeight, numberOfLinesRequired - numOfTitleLines, description, originalDescriptionHeight);

          if (numOfDescriptionLines === 0) {
            description.hide();
          }
        }
      } else {
        //all the title and description should be displayed
        if (this.props.current.item.isReadMoreOpen) {
          this.setState({ isReadMoreVisible: true });
        }
        title.css({ height: originalTitleHeight });
        description.css({ height: originalDescriptionHeight });
        description.show();
        title.css({ '-webkit-line-clamp': 'initial' });
        description.css({ '-webkit-line-clamp': 'initial' });
      }
    }
  }, {
    key: 'truncateElement',
    value: function truncateElement(availableHeight, numberOfLinesRequired, element, originalElementHeight) {
      var numOfElementLines = 0;

      element.css({ overflow: 'visible' });
      var elementHeight = originalElementHeight;
      var elementLineHeight = parseInt(element.css('line-height')) || 0;
      var originalNumberOfElementLines = Math.floor(elementHeight / elementLineHeight);
      numOfElementLines = Math.min(Math.floor(availableHeight / elementLineHeight), numberOfLinesRequired, originalNumberOfElementLines);

      if (numOfElementLines < originalNumberOfElementLines) {
        //need to truncate the element
        this.props.current.item.isReadMoreOpen = false;
        this.setState({ isReadMoreOpen: false });
        this.setState({ isReadMoreVisible: true });

        element.css({ '-webkit-line-clamp': numOfElementLines + '' });
        elementHeight = elementLineHeight * numOfElementLines;
        element.css({
          overflow: 'hidden',
          display: '-webkit-box',
          '-webkit-box-orient': 'vertical',
          height: elementHeight
        });
      } else {
        //all the element can be displayed
        if (this.props.current.item.isReadMoreOpen) {
          this.setState({ isReadMoreVisible: true });
        }
        element.css({ '-webkit-line-clamp': 'initial' });
        elementHeight = elementLineHeight * originalNumberOfElementLines;
      }
      return numOfElementLines;
    }
  }, {
    key: 'toggleReadMore',
    value: function toggleReadMore() {
      this.props.current.item.isReadMoreOpen = !this.props.current.item.isReadMoreOpen;
      this.setState({ isReadMoreOpen: this.props.current.item.isReadMoreOpen });
      this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
    }
  }, {
    key: 'handleSetMobileData',
    value: function handleSetMobileData(type, data) {
      var onSetMobileData = this.props.onSetMobileData;
      if (onSetMobileData) {
        onSetMobileData(type, data);
      }
    }
  }, {
    key: 'postShopRequest',
    value: function postShopRequest(type, data) {
      if (this.shopElement) {
        this.shopElement.postShopRequest(type, data);
      }
    }
  }, {
    key: 'addToCartRequest',
    value: function addToCartRequest() {
      if (this.shopElement) {
        this.shopElement.addToCartRequest();
      }
    }
  }, {
    key: 'isVisible',
    value: function isVisible() {
      return this.props.showInfo && this.props.current.hasInfo || this.props.showMobileShopFrame === true;
    }
  }, {
    key: 'getShopElements',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _this2 = this;

        var _ref2, cartApi, FullScreenShop, galleryInfo, galleryId, styleId, pageId, curItem, isImage, isShopVisible, shopFrameContainerStyle, _state, isStoreGallery, isMobile, shouldShowShopButtons, providerView, shouldShowAddToCartButton, cartItemsCount;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_utils.utils.isStoreGallery()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return new _promise2.default(function (resolve) {
                  require.ensure([], function (require) {
                    resolve(require('@wix/pro-gallery-artstore-statics'));
                  });
                });

              case 4:
                _ref2 = _context.sent;
                cartApi = _ref2.cartApi;
                FullScreenShop = _ref2.FullScreenShop;
                galleryInfo = this.props.galleryInfo;
                galleryId = galleryInfo && galleryInfo.galleryId;
                styleId = galleryInfo && galleryInfo.styleId;
                pageId = galleryInfo && galleryInfo.pageId;
                curItem = this.curItem = this.props.current.item;
                isImage = curItem.type === 'image' || curItem.type === 'picture';
                isShopVisible = this.props.showShopFrame && isImage;
                shopFrameContainerStyle = {};
                _state = this.state, isStoreGallery = _state.isStoreGallery, isMobile = _state.isMobile;

                if (!isShopVisible) {
                  shopFrameContainerStyle.visibility = 'hidden';
                }
                this.shopFrameElement = _react2.default.createElement(
                  'div',
                  { style: shopFrameContainerStyle },
                  _react2.default.createElement(FullScreenShop, {
                    ref: function ref(element) {
                      return _this2.shopElement = element;
                    },
                    item: curItem,
                    styleParams: this.props.styleParams,
                    styleId: styleId,
                    pageId: pageId,
                    additionalParams: _lodash2.default.merge({}, curItem.getDataForShop(), {
                      galleryId: galleryId
                    }),
                    locale: this.props.locale,
                    actions: this.props.actions,
                    deviceType: this.props.deviceType,
                    viewMode: this.props.viewMode,
                    onSetMobileData: function onSetMobileData(type, data) {
                      return _this2.handleSetMobileData(type, data);
                    },
                    connectedProviders: this.props.connectedProviders
                  })
                );
                this.shopButtons = null;
                shouldShowShopButtons = isStoreGallery && !isMobile && isImage;

                if (shouldShowShopButtons) {
                  providerView = this.props.providerView;
                  shouldShowAddToCartButton = this.props.isPreview || providerView && providerView.type === _mobileViewTypes2.default.singleProduct;
                  cartItemsCount = cartApi.getCartItemsCount(this.props.cartItems);


                  this.shopButtons = _react2.default.createElement(
                    'div',
                    null,
                    shouldShowAddToCartButton ? _react2.default.createElement(_fullscreenCartButton2.default, {
                      cartItems: this.props.cartItems,
                      onAddToCartRequest: function onAddToCartRequest() {
                        return _this2.props.onAddToCartRequest();
                      },
                      styleParams: this.props.styleParams
                    }) : null,
                    _react2.default.createElement(_fullscreenCheckoutLink2.default, {
                      cartItemsCount: cartItemsCount,
                      onClick: this.props.actions.onCheckout
                    })
                  );
                }
                this.setState({ hasShopElements: true });

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getShopElements() {
        return _ref.apply(this, arguments);
      }

      return getShopElements;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (_utils.utils.isStoreGallery()) {
        if (prevProps.current.item.id !== this.props.current.item.id) {
          // we are dealing with a new item
          if (this.state.isReadMoreVisible) {
            this.setState({ isReadMoreVisible: false });
          }
          this.setState({
            isReadMoreOpen: this.props.current.item.isReadMoreOpen,
            hasShopElements: false
          });
          this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
          this.getShopElements();
        }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_utils.utils.isStoreGallery()) {
        this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
        this.getShopElements();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var curItem = this.curItem = this.props.current.item;
      var isImage = curItem.type === 'image' || curItem.type === 'picture';
      var _state2 = this.state,
          isReadMoreVisible = _state2.isReadMoreVisible,
          isStoreGallery = _state2.isStoreGallery,
          isSmallScreen = _state2.isSmallScreen,
          isMobile = _state2.isMobile,
          isStoreMobile = _state2.isStoreMobile,
          isReadMoreOpen = _state2.isReadMoreOpen;

      var galleryInfo = this.props.galleryInfo;
      var galleryId = galleryInfo && galleryInfo.galleryId;
      var styleId = galleryInfo && galleryInfo.styleId;
      var pageId = galleryInfo && galleryInfo.pageId;

      var titleText = _utils.utils.getTitleOrFilename(curItem.title, curItem.fileName) || ''; //(curItem.isDemo ? curItem.demoTitle : ''); - remove default text from demo items until rewritten
      var title = titleText && this.props.styleParams.allowTitleExpand && !isStoreMobile ? _react2.default.createElement(
        'div',
        {
          className: 'fullscreen-side-bar-title',
          tabIndex: this.isVisible() ? _utils.utils.getTabIndex('fullscreenTitle') : -1,
          'aria-label': titleText,
          ref: function ref(title) {
            return _this3.titleElement = title;
          }
        },
        titleText
      ) : null;

      var descriptionText = curItem.description || ''; //(curItem.isDemo ? curItem.demoDescription : ''); - remove default text from demo items until rewritten
      var description = void 0;
      if (descriptionText && this.props.styleParams.allowDescriptionExpand && !isStoreMobile) {
        var descriptionClassName = 'fullscreen-side-bar-description';
        descriptionClassName += isStoreGallery ? ' pro-fullscreen-store' : '';
        description = _react2.default.createElement(
          'div',
          {
            className: descriptionClassName,
            tabIndex: this.isVisible() ? _utils.utils.getTabIndex('fullscreenDesc') : -1,
            ref: function ref(desc) {
              return _this3.descElement = desc;
            }
          },
          _react2.default.createElement(
            'div',
            {
              className: 'fullscreen-side-bar-description-line',
              style: { whiteSpace: 'pre-wrap' }
            },
            descriptionText
          )
        );
      } else {
        description = null;
      }

      var prettyExif = '';
      if (curItem.exif) {
        var camera = curItem.exif.Model;

        //todo - place separators using join

        var focalLength = curItem.exif.FocalLength ? _react2.default.createElement(
          'span',
          null,
          curItem.exif.FocalLength,
          'mm'
        ) : '';
        var fNumber = curItem.exif.FNumber ? _react2.default.createElement(
          'span',
          null,
          '\xA0\xA0/\xA0\xA0\u0192/',
          curItem.exif.FNumber
        ) : '';
        var roundExposureTime = Math.round(1 / Number(curItem.exif.ExposureTime));
        var exposureTime = roundExposureTime > 0 ? _react2.default.createElement(
          'span',
          null,
          '\xA0\xA0/\xA0\xA01/',
          roundExposureTime,
          's'
        ) : '';
        var isoSpeed = curItem.exif.IsoSpeed ? _react2.default.createElement(
          'span',
          null,
          '\xA0\xA0/\xA0\xA0ISO ',
          curItem.exif.IsoSpeed
        ) : '';

        var showExif = focalLength || fNumber || exposureTime || isoSpeed;

        prettyExif = showExif && this.props.styleParams.allowExifExpand && !isStoreGallery ? _react2.default.createElement(
          'div',
          { className: 'fullscreen-side-bar-exif' },
          _react2.default.createElement(
            'div',
            { className: 'exif-camera' },
            camera
          ),
          _react2.default.createElement(
            'div',
            { className: 'exif-shot' },
            focalLength,
            fNumber,
            exposureTime,
            isoSpeed
          )
        ) : '';
      }
      /*
       var allExif = [];
       for (var field in curItem.exif) {
       if (curItem.exif.hasOwnProperty(field)) {
       allExif.push(
       <p>{field}: {curItem.exif[field]}</p>
       )
       }
       }
        <p className="exif-more">see all</p>
       <div className="exif-all">
       {allExif}
       </div>
       */

      var linkClassNames = 'fullscreen-side-bar-link pro-fullscreen-link';
      linkClassNames += isStoreGallery ? ' pro-fullscreen-store' : '';

      var link = curItem.hasLink && this.props.styleParams.allowLinkExpand && !isStoreMobile && (isStoreGallery ? curItem.hasLink && (!isReadMoreVisible || isReadMoreOpen) : true) ? curItem.linkType === 'web' ? _react2.default.createElement(
        'a',
        {
          className: linkClassNames,
          href: curItem.linkUrl,
          target: curItem.linkOpenType,
          tabIndex: this.isVisible() ? _utils.utils.getTabIndex('fullscreenLink') : -1,
          'aria-label': curItem.linkText
        },
        curItem.linkText ? curItem.linkText : curItem.linkUrl
      ) : _react2.default.createElement(
        'a',
        {
          className: linkClassNames,
          onClick: function onClick() {
            return _this3.props.actions.navigate(curItem);
          },
          tabIndex: this.isVisible() ? _utils.utils.getTabIndex('fullscreenLink') : -1,
          'aria-label': curItem.linkText
        },
        curItem.linkText ? curItem.linkText : curItem.linkUrl
      ) : '';
      var readLess = _translationUtils2.default ? _translationUtils2.default.getByKey('Gallery_Read_Less') : 'read_less';
      var readMore = _translationUtils2.default ? _translationUtils2.default.getByKey('Gallery_Read_More') : 'read_more';
      var readMoreText = isReadMoreOpen ? readLess : readMore;
      var readMoreOrLess = isReadMoreVisible ? _react2.default.createElement(
        'div',
        {
          className: 'pro-fullscreen-read-more fullscreen-side-bar-description',
          onClick: function onClick() {
            return _this3.toggleReadMore();
          }
        },
        readMoreText
      ) : null;

      var sideBarSocial = this.props.styleParams.allowSocial && !_fullscreen.fullscreenVersionManager.useFullscreenNewSidebar() ? _react2.default.createElement(
        'div',
        {
          className: 'fullscreen-side-bar-social',
          style: this.props.styleParams.galleryAlignExpandIcons
        },
        _react2.default.createElement(
          'div',
          { className: 'fullscreen-social-share-box pro-fullscreen-open' },
          _react2.default.createElement(_fullscreenShareButtons2.default, { item: curItem })
        )
      ) : '';

      var separator = isStoreGallery ? null : _react2.default.createElement('div', { className: 'fullscreen-side-bar-separator' });

      var infoContainerClassName = 'fullscreen-side-bar-info-container';
      infoContainerClassName += isStoreGallery ? ' pro-fullscreen-store' : '';
      // infoContainerClassName += (isSmallScreen ? '' : ' mCustomScrollbar pro-fullscreen-custom-scroller');
      infoContainerClassName += isStoreGallery ? isSmallScreen ? '' : ' pro-fullscreen-custom-scroller' : '';

      var isSidebarOpened = this.isVisible() || !this.props.window.expanded && isStoreGallery && !this.state.isMobile;

      var style = {
        textAlign: this.props.styleParams.galleryAlignExpand,
        transform: 'scale(' + (isSidebarOpened ? 1 : 0) + ')'
      };

      return _react2.default.createElement(
        'div',
        {
          className: 'fullscreen-side-bar' + (isSidebarOpened ? ' pro-fullscreen-opened' : ' pro-fullscreen-closed') + (isSmallScreen ? ' pro-fullscreen-mobile' : '') + (isStoreGallery ? ' pro-fullscreen-store' : ''),
          style: style,
          dir: 'auto'
        },
        _react2.default.createElement(
          'div',
          { className: infoContainerClassName },
          _react2.default.createElement(
            'div',
            {
              ref: function ref(itemContainer) {
                _this3.itemContainer = itemContainer;
              }
            },
            title,
            description
          ),
          prettyExif,
          link,
          readMoreOrLess,
          _fullscreen.fullscreenVersionManager.useFullscreenNewSidebar() ? false : separator,
          _fullscreen.fullscreenVersionManager.useFullscreenNewSidebar() ? false : sideBarSocial,
          this.state.hasShopElements && this.shopFrameElement
        ),
        this.state.hasShopElements && this.shopButtonsElement
      );
    }
  }]);
  return FullscreenSidebar;
}(_react2.default.Component);

exports.default = FullscreenSidebar;